export const OVERALL_PERFORMANCE_PREVIEW_REQUEST = 'OVERALL_PERFORMANCE_PREVIEW_REQUEST';
export const OVERALL_PERFORMANCE_PREVIEW_SUCCESS = 'OVERALL_PERFORMANCE_PREVIEW_SUCCESS';
export const OVERALL_PERFORMANCE_PREVIEW_FAIL = 'OVERALL_PERFORMANCE_TYPE_FAIL';
